import $ from 'jquery';

const defaults = {
  sourceSelector: '.field-image.c1 img',
  destSelector: '.node',
  isPseudo: false,
};

function BackgroundImage(element, options) {
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.addBackgroundImage();
  this.ready();
}

BackgroundImage.prototype = {
  getSource() {
    return this.$element.find(this.settings.sourceSelector).attr('src');
  },
  addBackgroundImage() {
    const src = this.getSource();
    if (src && src.length) {
      if (this.settings.isPseudo) {
        this.$element.find('.node').prepend('<span class="pod-image-bg"></span>');
        this.$element.find('.pod-image-bg').css('background-image', `url(${src})`);
      } else {
        this.$element.find(this.settings.destSelector).css('background-image', `url(${src})`);
      }
      this.$element.addClass('hasImage');
    }
  },
  ready() {
    this.$element.addClass('ready');
    this.$element.find('.node-image').addClass('ready');
  },
};

export default BackgroundImage;



// WEBPACK FOOTER //
// ./BackgroundImage.js